import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import { usePois } from '../contexts/PoisContext'
import { setFlashMessage } from '../contexts/WebsiteContext'
import RidingList from '../components/PointOfinterestType/RidingList'
import MountainBikingPoints from '../components/PointOfinterestType/MountainBikingPoints'
import MountainBikingClassification from '../components/PointOfinterestType/MountainBikingClassification'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

const PoiTypeMountainBiking = () => {
  const poiType = 'MOUNTAIN_BIKING'
  const pageName = `POI_TYPE_${poiType}`
  const { t, i18n } = useTranslation()
  const { pois } = usePois()

  const filteredPois = pois.filter((poi) => poi.poiType.name === poiType)

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t(`${pageName}_PAGE_TITLE`)}
        description={t(`${pageName}_PAGE_DESCRIPTION`)}
      />

      <div className="container section py-4">
        <p className="lead">{t(`${pageName}_PAGE_DETAILS`)}</p>

        {filteredPois.length > 0 && <RidingList pois={filteredPois} />}

        <hr />
        <MountainBikingPoints />

        <hr />
        <MountainBikingClassification />

        <BottomImage name={pageName} lang={i18n.language} />
      </div>

      <Footer />
    </div>
  )
}

export default PoiTypeMountainBiking
